<template>
  <el-form-item label="Roles" prop="roles" :rules="validateField('Roles')">
    <div class="mb-1">
      <p class="text-opacity">You can only select one role in each group</p>
    </div>
    <el-select v-model="setRoles" placeholder="Select" multiple :disabled="loading">
      <el-option-group
        v-for="group in roleGroups"
        :key="group.id"
        :label="group.name"
      >
        <el-option
          v-for="role in group.roles"
          :key="role.id"
          :label="group.name + ' - ' + role.name"
          :value="role.id"
          :disabled="disableOptionInGroup(group.roles, role.id)"
          >{{ role.name }}
        </el-option>
      </el-option-group>
    </el-select>
  </el-form-item>
</template>

<script>

export default {
  name: "MemberRoleInput",
  props: {
    roles: {
      type: Array
    }
  },
  data() {
    return {
      loading: false,
      roleGroups: []
    };
  },
  computed: {
    setRoles: {
      get() {
        return this.roles;
      },
      set(value) {
        this.$emit("update:roles", value);
      }
    }
  },
  created() {
    this.getRoleGroups();
  },
  methods: {
    disableOptionInGroup(roles, role) {
      if (this.roles.length === 0) {
        return false;
      }

      const rolesInGroup = roles.map(role => role.id);

      const intersection = (...arrays) =>
        [...new Set([].concat(...arrays))].filter(toFind =>
          arrays.every(arr => arr.some(el => el === toFind))
        );

      if (intersection(rolesInGroup, this.roles).length === 0) {
        return false;
      }

      return !intersection(rolesInGroup, this.roles).includes(role);
    },
    getRoleGroups() {
      this.loading = true;
      const filters = [
        {
          field: "user_type_id",
          value: 7
        }
      ];
      this.$http
        .post(`roles/groups`, {
          method: "GET",
          params: `filters=${JSON.stringify(filters)}`
        })
        .then(response => {
          const resData = response.data;
          if (resData.status === "error") {
            this.handleErrors(resData);
          } else {
            this.roleGroups = resData.list ?? [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.notification("Error", "An unknown error occurred", "danger");
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
